export default __webpack_public_path__ + "static/signet_03-7aa627a49b9cc6f39aab4b4e6d391364.png";